import { fetchWrapperPublic } from "helpers/fetch-wrapper";
import { API_BASE_URL } from "helpers/constants";

export async function loginUserRequest(
    data: any // would define elsewhere
): Promise<Response> {
    return await fetchWrapperPublic.publicPost(
        `${API_BASE_URL}/user/login`, data
    );
}

export async function logoutRequest(
): Promise<Response> {
    return await fetchWrapperPublic.post(
        `${API_BASE_URL}/user/logout`
    );
}

export async function changePasswordRequest(data: any): Promise<Response> {
    return await fetchWrapperPublic.patch(
        `${API_BASE_URL}/user/change-password`, data
    );
}

export async function refreshTokenRequest(data: any): Promise<Response> {
    return await fetchWrapperPublic.publicPost(
        `${API_BASE_URL}/v1/user/refresh-token`, data
    );
}